import React from 'react';
import styles from './Overlay.module.scss';
const Overlay = ({ isOpen, onClose, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className={`${styles.overlay} ${isOpen ? styles.open : ''}`} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <h3 className={styles.title}>{title || 'Success'}</h3>
                <p className={styles.message}>{message}</p>
                <button className={styles.button} onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

export default Overlay;
